import axios from '@/extensions/axios'

const actions = {
  create ({ commit }, language) {
    return axios.post('languages', language).then(({ data }) => {
      commit('ADD', data)
    })
  },

  remove ({ commit }, key) {
    return axios.delete('languages/' + key).then(() => {
      commit('REMOVE', key)
    })
  },

  get ({ commit }) {
    return axios.get('languages').then(({ data }) => {
      commit('SET', data)
    })
  },

  find ({ state, commit }, id) {
    return axios.get('languages/' + id)
      .then(response => {
        return response
      })
  },

  update ({ commit }, language) {
    return axios.put('languages/' + language.id, language).then(({ data }) => {
      commit('UPDATE', data)
    })
  }
}

export default actions
